const initState=[];
const ClaimRecordReducer = (state = initState, action) => {
    switch(action.type) {
        case  'ClaimsRecordAction' : return  action.payload ;
        default: return state;
    }
}
export default ClaimRecordReducer;